import React, { FunctionComponent } from 'react';

import Flex from '@components/layout/flex';
import styled from 'styled-components';

import { MerchProductColor } from '@services/merch/types/api/merch-product-color';
import Typography from '@components/basics/typography';

interface MerchColorChoiceProps {
  className?: string;
  colors: MerchProductColor[];
}

const MerchColorChoice: FunctionComponent<MerchColorChoiceProps> = ({
  className,
  colors,
}) => {
  return (
    <Flex className={className || ''} alignItems="center">
      {colors &&
        colors.map((val: MerchProductColor, index: number) => {
          const numberToDisplay = colors.length - 5;
          return index < 7 ? (
            <Dot
              key={val.id}
              style={{
                backgroundColor: val.color,
                marginLeft: index === 0 ? '0' : '',
              }}
            />
          ) : (
            index === 7 && (
              <div key={val.color}>
                <Amount type="smaller">+{numberToDisplay}</Amount>
              </div>
            )
          );
        })}
    </Flex>
  );
};

export default MerchColorChoice;

const Dot = styled.div`
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.box};
  border: 1px solid ${({ theme }) => theme.colors.box};
  margin-left: -5px;
`;

const Amount = styled(Typography)`
  margin-left: 4px;
`;
